export enum SocketActionsTypes {
  SET_IS_SOCKET_CONNECT = 'socket/SET_IS_SOCKET_CONNECT',
  CONNECT_SOCKET = 'socket/CONNECT_SOCKET',
  DISCONNECT_SOCKET = 'socket/DISCONNECT_SOCKET',
  // EVENT = 'socket/EVENT',
}
